"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/wrapNativeSuper"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var camelizeRE = /-(\w)/g;

var camelize = function camelize(str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
};

var hyphenateRE = /\B([A-Z])/g;

var hyphenate = function hyphenate(str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase();
};

function getInitialProps(propsList) {
  var res = {};
  propsList.forEach(function (key) {
    res[key] = undefined;
  });
  return res;
}

function injectHook(options, key, hook) {
  options[key] = [].concat(options[key] || []);
  options[key].unshift(hook);
}

function callHooks(vm, hook) {
  if (vm) {
    var hooks = vm.$options[hook] || [];
    hooks.forEach(function (hook) {
      hook.call(vm);
    });
  }
}

function createCustomEvent(name, args) {
  return new CustomEvent(name, {
    bubbles: false,
    cancelable: false,
    detail: args
  });
}

var isBoolean = function isBoolean(val) {
  return /function Boolean/.test(String(val));
};

var isNumber = function isNumber(val) {
  return /function Number/.test(String(val));
};

function convertAttributeValue(value, name) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      type = _ref.type;

  if (isBoolean(type)) {
    if (value === 'true' || value === 'false') {
      return value === 'true';
    }

    if (value === '' || value === name || value != null) {
      return true;
    }

    return value;
  } else if (isNumber(type)) {
    var parsed = parseFloat(value, 10);
    return isNaN(parsed) ? value : parsed;
  } else {
    return value;
  }
}

function toVNodes(h, children) {
  var res = [];

  for (var i = 0, l = children.length; i < l; i++) {
    res.push(toVNode(h, children[i]));
  }

  return res;
}

function toVNode(h, node) {
  if (node.nodeType === 3) {
    return node.data.trim() ? node.data : null;
  } else if (node.nodeType === 1) {
    var data = {
      attrs: getAttributes(node),
      domProps: {
        innerHTML: node.innerHTML
      }
    };

    if (data.attrs.slot) {
      data.slot = data.attrs.slot;
      delete data.attrs.slot;
    }

    return h(node.tagName, data);
  } else {
    return null;
  }
}

function getAttributes(node) {
  var res = {};

  for (var i = 0, l = node.attributes.length; i < l; i++) {
    var attr = node.attributes[i];
    res[attr.nodeName] = attr.nodeValue;
  }

  return res;
}

function wrap(Vue, Component) {
  var isAsync = typeof Component === 'function' && !Component.cid;
  var isInitialized = false;
  var hyphenatedPropsList;
  var camelizedPropsList;
  var camelizedPropsMap;

  function initialize(Component) {
    if (isInitialized) return;
    var options = typeof Component === 'function' ? Component.options : Component; // extract props info

    var propsList = Array.isArray(options.props) ? options.props : Object.keys(options.props || {});
    hyphenatedPropsList = propsList.map(hyphenate);
    camelizedPropsList = propsList.map(camelize);
    var originalPropsAsObject = Array.isArray(options.props) ? {} : options.props || {};
    camelizedPropsMap = camelizedPropsList.reduce(function (map, key, i) {
      map[key] = originalPropsAsObject[propsList[i]];
      return map;
    }, {}); // proxy $emit to native DOM events

    injectHook(options, 'beforeCreate', function () {
      var _this = this;

      var emit = this.$emit;

      this.$emit = function (name) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this.$root.$options.customElement.dispatchEvent(createCustomEvent(name, args));

        return emit.call.apply(emit, [_this, name].concat(args));
      };
    });
    injectHook(options, 'created', function () {
      var _this2 = this; // sync default props values to wrapper on created


      camelizedPropsList.forEach(function (key) {
        _this2.$root.props[key] = _this2[key];
      });
    }); // proxy props as Element properties

    camelizedPropsList.forEach(function (key) {
      Object.defineProperty(CustomElement.prototype, key, {
        get: function get() {
          return this._wrapper.props[key];
        },
        set: function set(newVal) {
          this._wrapper.props[key] = newVal;
        },
        enumerable: false,
        configurable: true
      });
    });
    isInitialized = true;
  }

  function syncAttribute(el, key) {
    var camelized = camelize(key);
    var value = el.hasAttribute(key) ? el.getAttribute(key) : undefined;
    el._wrapper.props[camelized] = convertAttributeValue(value, key, camelizedPropsMap[camelized]);
  }

  var CustomElement = /*#__PURE__*/function (_HTMLElement) {
    (0, _inherits2.default)(CustomElement, _HTMLElement);

    var _super = _createSuper(CustomElement);

    function CustomElement() {
      var _this3;

      (0, _classCallCheck2.default)(this, CustomElement);

      var self = _this3 = _super.call(this);

      self.attachShadow({
        mode: 'open'
      });
      var wrapper = self._wrapper = new Vue({
        name: 'shadow-root',
        customElement: self,
        shadowRoot: self.shadowRoot,
        data: function data() {
          return {
            props: {},
            slotChildren: []
          };
        },
        render: function render(h) {
          return h(Component, {
            ref: 'inner',
            props: this.props
          }, this.slotChildren);
        }
      }); // Use MutationObserver to react to future attribute & slot content change

      var observer = new MutationObserver(function (mutations) {
        var hasChildrenChange = false;

        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];

          if (isInitialized && m.type === 'attributes' && m.target === self) {
            syncAttribute(self, m.attributeName);
          } else {
            hasChildrenChange = true;
          }
        }

        if (hasChildrenChange) {
          wrapper.slotChildren = Object.freeze(toVNodes(wrapper.$createElement, self.childNodes));
        }
      });
      observer.observe(self, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
      return _this3;
    }

    (0, _createClass2.default)(CustomElement, [{
      key: "vueComponent",
      get: function get() {
        return this._wrapper.$refs.inner;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this4 = this;

        var wrapper = this._wrapper;

        if (!wrapper._isMounted) {
          // initialize attributes
          var syncInitialAttributes = function syncInitialAttributes() {
            wrapper.props = getInitialProps(camelizedPropsList);
            hyphenatedPropsList.forEach(function (key) {
              syncAttribute(_this4, key);
            });
          };

          if (isInitialized) {
            syncInitialAttributes();
          } else {
            // async & unresolved
            Component().then(function (resolved) {
              if (resolved.__esModule || resolved[Symbol.toStringTag] === 'Module') {
                resolved = resolved.default;
              }

              initialize(resolved);
              syncInitialAttributes();
            });
          } // initialize children


          wrapper.slotChildren = Object.freeze(toVNodes(wrapper.$createElement, this.childNodes));
          wrapper.$mount();
          this.shadowRoot.appendChild(wrapper.$el);
        } else {
          callHooks(this.vueComponent, 'activated');
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        callHooks(this.vueComponent, 'deactivated');
      }
    }]);
    return CustomElement;
  }( /*#__PURE__*/(0, _wrapNativeSuper2.default)(HTMLElement));

  if (!isAsync) {
    initialize(Component);
  }

  return CustomElement;
}

var _default = wrap;
exports.default = _default;
